// extracted by mini-css-extract-plugin
export default {"form":"form--Cy5ha","loader":"loader--Bvt9c"};